import { useQuery } from '@tanstack/react-query'
import { userQueryOptions } from '@/core/auth/user-query'
import { type PlanFraming, planFraming } from '../lib/plan-framing'

// A passive read of the cached `me`: deciding the arm must never refetch it.
export function usePlanFraming(): PlanFraming {
  const { data } = useQuery({ ...userQueryOptions, enabled: false })
  return planFraming(data?.me)
}
